module.exports = __webpack_public_path__ + "static/media/map-control-settings.b9b1d442.svg";